import styled from "styled-components";

export const Container = styled.div`
    display: grid;
    grid-template-rows: max-content 1fr max-content;

    min-height: 100vh;
`;
